import request from "@/utils/request";

// 列表(主数据列表)
export function loadEmployeeListDataApi(data) {
  return request({
    url: "web/employee/listData",
    method: "post",
    data
  });
}
// 导出
export function loadEmployeeExportDataApi(data) {
  return request({
    url: "web/employee/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateEmployeeApi(data) {
  return request({
    url: "web/employee/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initEmployeeApi(data) {
  return request({
    url: "web/employee/init",
    method: "post",
    data
  });
}

// 获取职员列表
export function getEmployeeListApi(data) {
  return request({
      url: "web/employee/listSelectData",
      method: "post",
      data
  });
}

// 根据用户获取职员列表
export function getEmployeeListByUserApi(data) {
  return request({
      url: "web/employee/listSelectDataByUser",
      method: "post",
      data
  });
}

// 根据用户Ids获取职员列表
export function getEmployeeListByUserIdsApi(data) {
  return request({
      url: "web/employee/findEmployeeListByUserIds",
      method: "post",
      data
  });
}